import { Component } from '@angular/core';
import { IonicPage, NavController,  NavParams, ViewController } from 'ionic-angular';
import { GlobalConstants } from '../../models/global-constants'

@IonicPage()
@Component({
  selector: 'page-line-up-editor',
  templateUrl: 'line-up-editor.html',
})
export class LineUpEditorPage {

  items: any;
  playersTeamWhite: any[];
  goaliesTeamWhite: any[];
  defendersTeamWhite: any[];
  forwardsTeamWhite: any[];
  
  playersTeamBlack: any[];
  goaliesTeamBlack: any[];
  defendersTeamBlack: any[];
  forwardsTeamBlack: any[];
  
  constructor(public navCtrl: NavController,
              public navParams: NavParams,
              public viewCtrl: ViewController
              ) {
      this.items = navParams.data;
      console.log("ctor: " + this.items);
      this.shufflePlayers();  
  }
  
  saveModal() {
    let teamlist = this.generateOutput();
    this.viewCtrl.dismiss(teamlist);
  }


  generateOutput() {
    this.prepareTeams();
    var teamlist = { 
      // "teamBlack" : this.playersTeamBlack, 
      // "teamWhite" : this.playersTeamWhite,
      "goaliesBlack" : this.goaliesTeamBlack,
      "defendersBlack" : this.defendersTeamBlack,
      "forwardsBlack" : this.forwardsTeamBlack,
      "goaliesWhite" : this.goaliesTeamWhite,
      "defendersWhite" : this.defendersTeamWhite,
      "forwardsWhite" : this.forwardsTeamWhite
    };
    return teamlist; 
  }

  closeModal() {
    this.navCtrl.pop();
  }

  prepareTeams(){

    var onlyPlayers = [];
    for(var blackPlayer of this.playersTeamBlack){
      if(blackPlayer.Name.startsWith(GlobalConstants.PREFIX_GOALIE)
      || blackPlayer.Name.startsWith(GlobalConstants.PREFIX_GUEST_GOALIE))
      {
          this.goaliesTeamBlack.push(blackPlayer);
      }
      else{
          onlyPlayers.push(blackPlayer);   
      }
    }
    this.playersTeamBlack = onlyPlayers;

    onlyPlayers = [];
    for(var whitePlayer of this.playersTeamWhite){
      if(whitePlayer.Name.startsWith(GlobalConstants.PREFIX_GOALIE)
      || whitePlayer.Name.startsWith(GlobalConstants.PREFIX_GUEST_GOALIE)){
          this.goaliesTeamWhite.push(whitePlayer);
      }
      else {
          onlyPlayers.push(whitePlayer);
      }
    }
    this.playersTeamWhite = onlyPlayers;
  }

  shufflePlayers(){
    
    this.playersTeamWhite = [];
    this.playersTeamBlack = [];
    this.goaliesTeamBlack = [];
    this.goaliesTeamWhite = [];
    this.defendersTeamBlack = [];
    this.defendersTeamWhite = [];
    this.forwardsTeamBlack = [];
    this.forwardsTeamWhite = [];

    var counter = 0;
    var goalieCounter = 0;
    for(var item of this.items)
    {
      console.log("shufflePlayer : " + item);
      if(this.isGoalie(item))
      {
        if(goalieCounter % 2 == 0) {
          this.goaliesTeamWhite.push(item);
        } else {
          this.goaliesTeamBlack.push(item);
        }
        goalieCounter++;
      }
      else {

        var modValue = counter % 4;
        switch(modValue){
          case 0:
            this.defendersTeamWhite.push(item);
            break;
          case 1:
            this.defendersTeamBlack.push(item);
            break;
          case 2:
            this.forwardsTeamWhite.push(item);
            break;
          case 3:
            this.forwardsTeamBlack.push(item);
            break;
        }
        counter++;
  /*      
        if(counter % 2 == 0) {
          this.playersTeamWhite.push(item);
        }
        else
        {
          this.playersTeamBlack.push(item);
        }
        counter++;
  */
      }
    }
  }

  switchTeam(toTeam: string, position: string,  item: any){
    switch(toTeam){
      case 'red':
          this.playersTeamBlack = this.playersTeamBlack.filter(x => x.Id != item.Id);
          this.playersTeamWhite.push(item);
          switch(position) {
            case "goalie":
                this.goaliesTeamBlack = this.goaliesTeamBlack.filter(x => x.Id != item.Id);
                this.goaliesTeamWhite.push(item);
              break;
            case "defender":
                this.defendersTeamBlack = this.defendersTeamBlack.filter(x => x.Id != item.Id);
                this.defendersTeamWhite.push(item);
              break;
            case "forward":
                this.forwardsTeamBlack = this.forwardsTeamBlack.filter(x => x.Id != item.Id);
                this.forwardsTeamWhite.push(item);
              break;
          }
        break;
      case 'black':
          this.playersTeamWhite = this.playersTeamWhite.filter(x => x.Id != item.Id);
          this.playersTeamBlack.push(item);
          switch(position) {
            case "goalie":
                this.goaliesTeamWhite = this.goaliesTeamWhite.filter(x => x.Id != item.Id);
                this.goaliesTeamBlack.push(item);
              break;
            case "defender":
                this.defendersTeamWhite = this.defendersTeamWhite.filter(x => x.Id != item.Id);
                this.defendersTeamBlack.push(item);
              break;
            case "forward":
                this.forwardsTeamWhite = this.forwardsTeamWhite.filter(x => x.Id != item.Id);
                this.forwardsTeamBlack.push(item);
              break;
          }
        break;
    }
  }
  
  swapPosition(withinTeam: string, toPosition: string,  item: any){
    
    switch(withinTeam){
      case 'red':
          switch(toPosition) {
            case "goalie":
                this.goaliesTeamWhite = this.goaliesTeamWhite.filter(x => x.Id != item.Id);
                this.goaliesTeamWhite.push(item);
              break;
            case "defender":
                this.forwardsTeamWhite = this.forwardsTeamWhite.filter(x => x.Id != item.Id);
                this.defendersTeamWhite.push(item);
              break;
            case "forward":
                this.defendersTeamWhite = this.defendersTeamWhite.filter(x => x.Id != item.Id);
                this.forwardsTeamWhite.push(item);
              break;
          }
        break;
      case 'black':
          switch(toPosition) {
            case "goalie":
                this.goaliesTeamBlack = this.goaliesTeamBlack.filter(x => x.Id != item.Id);
                this.goaliesTeamBlack.push(item);
              break;
            case "defender":
                this.forwardsTeamBlack = this.forwardsTeamBlack.filter(x => x.Id != item.Id);
                this.defendersTeamBlack.push(item);
              break;
            case "forward":
                this.defendersTeamBlack = this.defendersTeamBlack.filter(x => x.Id != item.Id);
                this.forwardsTeamBlack.push(item);
              break;
          }
        break;
    }
  }

  isGoalie(item: any) {
    if(item.Name.startsWith("00")
      || item.Name.startsWith("GG")
    ) {
      return true;
    }
    return false;
  }
}



// WEBPACK FOOTER //
// ./src/pages/line-up-editor/line-up-editor.ts